export default __webpack_public_path__ + "static/media/good.0a3f8465.svg";